<template>
  <div class="daily-reports">
    <b-container fluid>
      <h1>Daily Reports</h1>
      <b-row class="print-hidden">
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button @click="cleanFilterInfo()" variant="primary"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="print-hidden">
        <b-col cols="3">
          <b-pagination
            v-model="currentPage"
            :page="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
        <b-col cols="3">
          <b-form-datepicker v-model="time_range.start" placeholder="start date"></b-form-datepicker> 
        </b-col>
        <b-col cols="3">
          <b-form-datepicker v-model="time_range.end" placeholder="end date"></b-form-datepicker>
        </b-col>
        <b-col cols="2">
          <b-button-group>
            <b-button variant="primary" @click="submitTimeRange()">Submit</b-button>
            <b-button variant="secondary" @click="resetTimeRange()">Reset</b-button>
          </b-button-group>
        </b-col>
      </b-row>

      <b-button class="print-hidden" variant="primary" @click="showModal('modal-add-daily-report')">Add</b-button>

      <b-table
        class="pointer mt-2"
        id="my-table"
        responsive
        striped
        hover
        @row-clicked="myRowClickHandler"
        :fields="daily_report_fields"
        :filter="filterCriteria"
        :items="displayed_reports"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >
    
      <!-- <template #cell(actions)="row">
        <b-button class="table-button" size=sm variant="primary" @click="view_daily_report(row.item)">View</b-button>
        <b-button class="table-button ml-1" size=sm variant="danger" @click="delete_daily_report(row.item.id)">Delete</b-button>
      </template> -->

      </b-table>
    </b-container>

    <b-modal id="modal-delete-daily-report"
      title="Delete confirmation"
      hide-footer>
      <p>This operation will delete a daily report.</p>
      <div class="modal-footer mt-1">
        <b-button variant="secondary" @click="hideModal('modal-delete-daily-report')"> Cancel </b-button>
        <b-button type="submit" variant="danger" @click="delete_daily_report_task()"> Delete </b-button>
      </div>
    </b-modal>

    <!-- ADD DAILY REPORT -->
    <b-modal size="lg" id="modal-add-daily-report" hide-footer title="Add daily report">
      <b-form @submit.prevent="add_daily_report">
        <label for="daily_report_date">Date:</label>
        <b-form-datepicker type="date"
          id="daily_report_date"
          v-model="new_daily_report.date"
          class="form-control"></b-form-datepicker>

        <label for="daily_report_name">Customer Name:</label>
        <b-input type="text" 
          id="daily_report_name" 
          v-model="new_daily_report.customer_name" 
          required></b-input>

        <label for="customer_phone">Customer Phone:</label>
        <b-input type="text" 
          id="customer_phone" 
          v-model="new_daily_report.customer_phone" 
          ></b-input>

        <label for="how_did_you_find_us">How did you find us:</label>
        <b-form-select id="how_did_you_find_us"
          v-model="new_daily_report.how_did_you_find_us" 
          :options="lead_source_names"
          required></b-form-select>

        <label for="cemetery_name">Cemetery:</label>
        <b-form-select id="cemetery"
          v-model="new_daily_report.cemetery_name" 
          :options="cemetery_names"
          ></b-form-select>

        <label for="funeral_provider">Funeral Provider:</label>
        <b-form-select id="follower"
          v-model="new_daily_report.funeral_provider" 
          :options="funeral_provider_names"
          ></b-form-select>

        <label for="follower">Who is following:</label>
        <!-- <p v-if="this.user.role == 'sales'">{{this.user.name}}</p> -->
        <b-form-select
          id="follower"
          v-model="new_daily_report.follower" 
          :options="sales_names"
          required></b-form-select>

        <label for="customer_status">Status:</label>
        <b-form-select 
          v-model="new_daily_report.status"
          :options="status_names"
          required></b-form-select>

        <label v-if="this.new_daily_report.status == 'fail'" for="failed_reason">Reason:</label>
        <b-form-input id="new_failed_reason"
          v-if="this.new_daily_report.status == 'fail'"
          v-model="this.new_daily_report.failed_reason"
          required></b-form-input>

        <label for="customer_enquiry">Customer Enquiry:</label>
        <b-textarea type="text" 
          id="customer_enquiry" 
          v-model="new_daily_report.customer_enquiry" 
          rows="5"
          ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-add-daily-report')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- VIEW DAILY REPORT -->
    <b-modal size="lg" id="modal-view-daily-report" hide-footer title="View dail report">
      <b-form @submit.prevent="edit_daily_report">
        <strong>Create Date:</strong>
        <b-form-datepicker type="date"
          v-model="viewed_daily_report.date"
          required
          class="form-control"></b-form-datepicker>

        <!-- <strong>Time:</strong>
        <b-form-timepicker
          v-model="viewed_daily_report.time"
          required></b-form-timepicker> -->

        <strong>Customer Name:</strong>
        <b-input type="text"
          v-model="viewed_daily_report.customer_name" 
          required></b-input>

        <strong>Customer Phone:</strong>
        <b-input v-model="viewed_daily_report.customer_phone"></b-input>

        <strong>How did you find us:</strong>
        <b-form-select id="how_did_you_find_us"
          v-model="viewed_daily_report.how_did_you_find_us" 
          :options="lead_source_names"
          ></b-form-select>

        <strong for="cemetery_name">Cemetery:</strong>
        <b-form-select id="cemetery"
          v-model="viewed_daily_report.cemetery_name" 
          :options="cemetery_names"
          ></b-form-select>

        <strong>Funeral Provider:</strong>
        <b-form-select v-model="viewed_daily_report.funeral_provider"
          :options="funeral_provider_names"
          ></b-form-select>

        <strong>Who is following:</strong>
        <b-form-select v-model="viewed_daily_report.follower"
          :options="sales_names"
          required></b-form-select>

        <strong for="customer_status">Status:</strong>
        <b-form-select 
          v-model="viewed_daily_report.status"
          :options="status_names"
          required></b-form-select>

        <label v-if="this.viewed_daily_report.status == 'fail'" for="failed_reason">Reason:</label>
        <b-form-input id="new_failed_reason"
          v-if="this.viewed_daily_report.status == 'fail'"
          v-model="viewed_daily_report.failed_reason"
          required></b-form-input>

        <strong>Customer Enquiry:</strong>
        <b-textarea rows="5" v-model="viewed_daily_report.customer_enquiry"></b-textarea>
          
        <div class="modal-footer">
          <b-button v-if="this.user.role == 'admin'" variant="danger" @click="delete_daily_report(viewed_daily_report.id)">Delete</b-button>
          <b-button @click="hideModal('modal-view-daily-report')"> Return </b-button>
          <b-button variant="warning" type="submit"> Update </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default ({
  computed: {
    rows: {
      get() {
        if (this.daily_reports.length == 0) {
          return 100;
        } else {
          return this.daily_reports.length;
        }
      },
      set(newRows) {
        return newRows
      }
    },
  },
  created() {
    this.set_global_date();

    if (this.user.role == "sales") {
      firebase.firestore().collection("daily_reports").where("follower", "==", this.user.name).orderBy('date', "desc").onSnapshot((collection) => {
        this.daily_reports = [];
        this.daily_reports = collection.docs.map(doc => doc.data());
        this.displayed_reports = this.daily_reports;
      });
    } else {
      firebase.firestore().collection("daily_reports").orderBy('date', "desc").onSnapshot((collection) => {
        this.daily_reports = [];
        this.daily_reports = collection.docs.map(doc => doc.data());
        this.displayed_reports = this.daily_reports;
      });
    }

    firebase.firestore().collection("saless").onSnapshot((collection) => {
      this.sales = [];
      this.sales_names = [];
      this.sales = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.sales.length; i++) {
        this.sales_names.push(this.sales[i].name);
      }
    });

    firebase.firestore().collection('lead_sources').orderBy('name').onSnapshot((collection) => {
      this.lead_sources = [];
      this.lead_sources = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.lead_sources.length; i++) {
        this.lead_source_names.push(this.lead_sources[i].name);
      }
    });

    firebase.firestore().collection('funeral_providers').orderBy('name').onSnapshot((collection) => {
      this.funeral_providers = [];
      this.funeral_providers = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.funeral_providers.length; i++) {
        this.funeral_provider_names.push(this.funeral_providers[i].name);
      }
    });

    firebase.firestore().collection('cemeteries').orderBy('name').onSnapshot((collection) => {
      this.cemeteries = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.cemeteries.length; i++) {
        this.cemetery_names.push(this.cemeteries[i].name);
      }
    });

  },
  props: {
    user: Object,
  },
  data() {
    return {
      time_range: {
        start: "",
        end: "",
      },
      time_filtered_reports: [],
      displayed_reports: [],
      funeral_providers: [],
      funeral_provider_names: [],
      lead_sources: [],
      lead_source_names: [],
      sales: [],
      sales_names: [],
      perPage: 20,
      currentPage: 1,
      filterCriteria: "",
      tableIsBusy: false,
      deleted_daily_report_id: "",
      daily_report_fields: [
        { key: 'date', label: 'Date'},
        { key: 'customer_name', label: 'Customer Name'},
        { key: 'customer_phone', label: 'Customer Phone'},
        { key: 'how_did_you_find_us', label: 'Lead Source'},
        { key: 'cemetery_name', label: 'Cemetery'},
        { key: 'funeral_provider', label: 'Funeral Provider'},
        { key: 'follower', label: 'sales'},
        { key: 'status', label: 'status'},
      ],
      daily_reports: [],
      new_daily_report: {
        branch: "",
        cemetery_name: "",
        created_by: "",
        follower: this.user.name,
        created_date: "",
        customer_enquiry: "",
        customer_name: "",
        customer_phone: "",
        date: "",
        funeral_provider: "",
        how_did_you_find_us: "",
        id: "",
        is_sales_contract_signed: "",
        status: "pending",
        failed_reason: "",
      },
      viewed_daily_report: {
        branch: "",
        cemetery_name: "",
        created_by: "",
        follower: "",
        created_date: "",
        customer_enquiry: "",
        customer_name: "",
        customer_phone: "",
        date: "",
        funeral_provider: "",
        how_did_you_find_us: "",
        id: "",
        is_sales_contract_signed: "",
        status: "",
        failed_reason: "",
      },
      cemeteries: [],
      cemetery_names: [],
      status_names: [
        "success",
        "pending",
        "fail"
      ],
    }
  },
  methods: {
    myRowClickHandler(item) {
      // console.log(item);
      // console.log(this.user);
      this.view_daily_report(item);
    },
    delete_daily_report(id) {
      if (this.user.role != "admin") {
        alert("You do not have authority.");
      } else {
        this.deleted_daily_report_id = id;
        this.showModal("modal-delete-daily-report");
      }
    },
    delete_daily_report_task() {
      firebase.firestore().collection("daily_reports").doc(this.deleted_daily_report_id).delete()
        .then(() => {
          this.hideModal("modal-delete-daily-report");
          this.hideModal("modal-view-daily-report");
          alert("delete successfully");
        });
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    add_daily_report() {
      const new_daily_report_ref = firebase.firestore().collection("daily_reports").doc();

      this.new_daily_report.id = new_daily_report_ref.id;
      this.new_daily_report.created_date = this.today;
      this.new_daily_report.year_month = this.new_daily_report.created_date.substring(0, 7);
      this.new_daily_report.day = parseInt(this.new_daily_report.created_date.substring(8,10));
      this.new_daily_report.created_by = this.user;
      this.new_daily_report.created_by_name = this.user.name;
      this.new_daily_report.date_timestamp = new Date(this.new_daily_report.date);
      new_daily_report_ref.set(this.new_daily_report).then(() => {
        this.hideModal("modal-add-daily-report");
        this.new_daily_report = {
          branch: "",
          cemetery_name: "",
          created_by: "",
          follower: "",
          created_date: "",
          customer_enquiry: "",
          customer_name: "",
          customer_phone: "",
          date: this.today,
          funeral_provider: "",
          how_did_you_find_us: "",
          id: "",
          is_sales_contract_signed: "",
          status: "",
          failed_reason: "",
        };
      });
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, '0');
      var mm = String(date_time.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + '-' + mm + '-' + dd;
      this.new_daily_report.date = this.today;
    },
    view_daily_report(daily_report) {
      this.viewed_daily_report = daily_report;
      console.log(this.viewed_daily_report);
      this.showModal('modal-view-daily-report');
    },
    edit_daily_report() {
      this.viewed_daily_report.date_timestamp = new Date(this.viewed_daily_report.date);
      firebase.firestore().collection("daily_reports").doc(this.viewed_daily_report.id)
        .set(this.viewed_daily_report,
          {merge: true})
        .then(() => {
          this.hideModal('modal-view-daily-report');
          alert("Modify successfully");
        });
    },
    submitTimeRange() {
      var start = null;
      var end = null;

      if (this.time_range.start == "" && this.time_range.end == "") return;

      if (this.time_range.start != "") {
        start = new Date(this.time_range.start);
      }

      if (this.time_range.end != "") {
        end = new Date(this.time_range.end);
      }
    
      if (this.time_range.start == "" && this.time_range.end != "") {
        firebase.firestore().collection("daily_reports")
          .where('date_timestamp', '<=', end)
          .orderBy('date_timestamp', "desc")
          .onSnapshot((collection) => {
            this.time_filtered_reports = [];
            this.time_filtered_reports = collection.docs.map(doc => doc.data());
            this.displayed_reports = this.time_filtered_reports;
        });
      }

      if (this.time_range.start != "" && this.time_range.end == "") {
        console.log(start);
        firebase.firestore().collection("daily_reports")
          .where('date_timestamp', '>=', start)
          .orderBy('date_timestamp', "desc")
          .onSnapshot((collection) => {
            this.time_filtered_reports = [];
            this.time_filtered_reports = collection.docs.map(doc => doc.data());
            this.displayed_reports = this.time_filtered_reports;
        });
      }

      if (this.time_range.start != "" && this.time_range.end != "") {
        firebase.firestore().collection("daily_reports")
          .where('date_timestamp', '>=', start)
          .where('date_timestamp', '<=', end)
          .orderBy('date_timestamp', "desc")
          .onSnapshot((collection) => {
            this.time_filtered_reports = [];
            this.time_filtered_reports = collection.docs.map(doc => doc.data());
            this.displayed_reports = this.time_filtered_reports;
        });
      }
    },
    resetTimeRange() {
      this.displayed_reports = this.daily_reports;
    },
    cleanFilterInfo() {
      this.filterCriteria = '';
    },
  }
})
</script>

<style scoped>
@media print {
  .print-hidden {
    visibility: hidden;
  }
}
</style>